<div class="table-container">
    <div style="margin-bottom: 0.5em">
        <button
            type="button"
            pButton
            severity="primary"
            pTooltip="Download"
            icon="pi pi-download"
            (click)="dtCheckup.exportCSV()"
            style="margin-right: 0.5em"
        ></button>
        <button
            type="button"
            pButton
            class="p-button-secondary"
            pTooltip="Clear All Filters"
            icon="pi pi-filter-slash"
            (click)="clearAllFilters()"
            label="Clear Filters"
        ></button>
    </div>
    <p-table stripedRows [value]="checkups"

        dataKey="MsgEntityID"
        [globalFilterFields]="['ProcessTitle']"
        [style]="{ 'min-width': '70em', 'height': '70vh' }"
        scrollHeight="70vh"
        [scrollable]="true"
        [columns]="cols"
        #dtCheckup
    >
        <ng-template pTemplate="emptymessage">
            <tr>
                <td colspan="7" style="text-align: center">
                    <div class="tabulator-placeholder">
                        <span> No Data Available </span>
                    </div>
                </td>
            </tr>
        </ng-template>
        <ng-template #header let-item>
            <tr>
                <!-- Status -->
                <th class="status-cell" pSortableColumn="MsgStatus"></th>
                <!-- Category -->
                <th pSortableColumn="CatDescription">
                    Category
                    <p-sortIcon
                        field="CatDescription"
                        ariaLabel="Activate to sort"
                        ariaLabelDesc="Activate to sort in descending order"
                        ariaLabelAsc="Activate to sort in ascending order"
                    ></p-sortIcon>
                    <p-columnFilter type="text" matchMode="contains" field="CatDescription" display="menu" class="ml-auto" />
                </th>
                <!-- Process -->
                <th pSortableColumn="ProcessTitle">
                    Process
                    <p-sortIcon
                        field="ProcessTitle"
                        ariaLabel="Activate to sort"
                        ariaLabelDesc="Activate to sort in descending order"
                        ariaLabelAsc="Activate to sort in ascending order"
                    ></p-sortIcon>
                    <p-columnFilter type="text" matchMode="contains" field="ProcessTitle" display="menu" class="ml-auto" />
                </th>
                <!-- Date -->
                <th pSortableColumn="MsgDate">
                    Date
                    <p-sortIcon
                        field="MsgDate"
                        ariaLabel="Activate to sort"
                        ariaLabelDesc="Activate to sort in descending order"
                        ariaLabelAsc="Activate to sort in ascending order"
                    ></p-sortIcon>
                    <p-columnFilter type="text" matchMode="contains" field="MsgDate" display="menu" class="ml-auto" />
                </th>
                <!-- Name -->
                <th pSortableColumn="MsgEntity">
                    Name
                    <p-sortIcon
                        field="MsgEntity"
                        ariaLabel="Activate to sort"
                        ariaLabelDesc="Activate to sort in descending order"
                        ariaLabelAsc="Activate to sort in ascending order"
                    ></p-sortIcon>
                    <p-columnFilter type="text" matchMode="contains" field="MsgEntity" display="menu" class="ml-auto" />
                </th>
                <!-- Message -->
                <th>
                    Message
                    <p-columnFilter type="text" matchMode="contains" field="MsgText" display="menu" class="ml-auto" />
                </th>
                <!-- Action -->
                <th>Action</th>
            </tr>
        </ng-template>
        <ng-template #body let-item>
            <tr [pEditableRow]="item"
                [pEditableRowDisabled]="item.IsReadOnly"
            >
                <!-- Status -->
                <td class="status-cell">
                    <ef-status-icon
                        [status]="item?.MsgStatus"
                        [message]="item?.MsgAction"
                    ></ef-status-icon>
                </td>
                <!-- Category -->
                <td>
                    {{ item?.CatDescription }}
                </td>
                <!-- Process -->
                <td>
                    <a
                        [uiSref]="
                            this.ss.get(
                                (
                                    this.processes
                                    | itemlookup: 'ProcessID':item?.MsgProcessID
                                )?.RouteName
                            )
                        "
                        >{{ item?.ProcessTitle }}</a
                    >
                </td>
                <!-- Date -->
                <td>
                    {{ item?.MsgDate | date: 'MM/dd/yyyy' }}
                </td>
                <!-- Name -->
                <td>
                    {{ item?.MsgEntity }}
                </td>
                <!-- Message -->
                <td>
                    {{ item?.MsgText }}
                </td>
                <!-- Action -->
                <td>
                    {{ item?.MsgAction }}
                </td>
            </tr>
        </ng-template>
    </p-table>
</div>
